import { autoinject, transient, useView } from "aurelia-framework";
import { QueriesClientService } from "../../../../../../services/queries/queries-client.services";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { VetClientModel, VettingType } from "../../../../../../models/vetting/vetting.models";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import * as moment from "moment";
import { SignalClientService } from "@rightship-tech/common-ui/services/basic/signal-client.service";
import { SignalFunctions } from "../../../../../../services/basics/signal-functions";
import { BaseHistoryTrail } from "../../../../common/base-history-trail";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
@transient()
@useView('views/pages/modules/vetting/steps/vet-history-trail/vet-history-trail.html')
export class VetHistoryTrail extends BaseHistoryTrail<VetClientModel> {

    public audits: any[] = [];

    constructor(private queriesClientService: QueriesClientService, notificationClientService: NotificationClientService, i18N: I18N,
        private signalClientService: SignalClientService, configService: ConfigService) {
        super(configService, notificationClientService, i18N);
    }

    protected onActivated() {
        this.refreshData();
    }

    public refreshData() {
        this.queriesClientService.getData(`/odata/RightShipAudits/Genesis.GetAudits(entityTypeId=${EntityTypes.Vet},entityId=${this.item.vetId})?$orderby=timestamp desc`).then(x => {
            this.audits = x.value;
        });
    }

    getFormattedDate(date) {
        return moment(date).format('DD MMM YYYY HH:mm');
    }

    attached() {
        if (this.item.vettingTypeId == VettingType.FullVet)
            this.signalClientService.subscribe(SignalFunctions.vetHistoryChanged, this.onVetHistoryChanged);
        if (this.item.vettingTypeId == VettingType.AutoScreening)
            this.signalClientService.subscribe(SignalFunctions.autoScreeningHistoryChanged, this.onVetHistoryChanged);
    }


    detached() {
        if (this.item.vettingTypeId == VettingType.FullVet)
            this.signalClientService.unsubscribe(SignalFunctions.vetHistoryChanged, this.onVetHistoryChanged);
        if (this.item.vettingTypeId == VettingType.AutoScreening)
            this.signalClientService.unsubscribe(SignalFunctions.autoScreeningHistoryChanged, this.onVetHistoryChanged);
    }

    protected onVetHistoryChanged = (params: { vetId: number }) => {
        if (this.item.vetId != params.vetId) return;

        this.refreshData();
    }
}